module.exports = __webpack_public_path__ + "static/media/trust-wallet.a4d67bb9.svg";